<template>
    <div :class="[$style['mds-layout-grid']]" :data-mds-version="version">
        <slot></slot>
    </div>
</template>

<script>
    import { computed } from 'vue';
    import packageInfo from '../package.json';
    const { name, version } = packageInfo;

    export default {
        name: 'MdsLayoutGrid',
        props: {
            gutters: {
                type: String,
                default: '32px',
                validator(value) {
                    return ['32px', 'none'].indexOf(value) !== -1;
                },
                docs: {
                    validation: 'One of: `32px`, `none`.',
                    description: 'Sets the layout grid gutter width.',
                },
            },
        },
        provide() {
            return {
                gutters: computed(() => this.gutters),
            };
        },
        data() {
            return {
                version: `${name}-${version}`,
            };
        },
    };
</script>

<style lang="scss" module>
    @use './layout-grid.scss';
</style>
